import React from "react";
import BlogBanner from "../sections/blog/BlogBanner";
import BlogList from "../sections/blog/BlogList";

const Blog: React.FC = () => {
  return (
    <div>
      <BlogBanner />
      <BlogList />
    </div>
  );
};

export default Blog;
